import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/routes/website';
import AuthService from '@/services/auth.service';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const user = AuthService.getUser();
  const setupPath = '/v1/auth/setup-password';
  const isAuthPath = to.path.split('/').includes('auth');
  const isOtherPath = to.path.split('/').includes('other');
  const loginNotAllowed = !isAuthPath && !user && !isOtherPath;

  const isImpersonating = localStorage.getItem('isImpersonating') === 'true';

  // Force password change: redirect to setup-password for ALL paths except the
  // setup page itself and sign-out — including other auth pages like /reset,
  // which would otherwise let users bypass the forced change via the token flow.
  // Skip the redirect when impersonating so admins aren't sent to the sevener's setup page.
  if (user?.force_password_change && !isImpersonating && to.path !== setupPath && to.name !== 'sign_out') {
    return next(setupPath);
  }

  if (isAuthPath && user && !user?.force_password_change) {
    next('/v1/trainings');
  } else if (loginNotAllowed) {
    // Keep where they were going so a connector's consent link survives the login.
    next({ path: '/v1/auth', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;
